import http from "../http-common";

const paths = {
  assureurs: "/admin/assureurs",
  prestations: "/admin/prestations",
  secteurs: "/admin/secteurs",
  specialites: "/admin/specialites",
  "type-sub-terr": "/admin/type-sub-terr",
  "sub-terr": "/admin/sub-terr",
  "type-structures": "/admin/type-structures",
  structures: "/admin/structures",
  services: "/admin/services",
  "str-prt-ass": "/admin/str-prt-ass",
  users: "/admin/users",
  "user-service": "/admin/user-service",
  "indis-mng-sec": "/admin/indis-mng-sec",
  "user-by-email": "/admin/users/by-email",
  "habiliter-medecin": "/admin/habiliter-medecin"
};

class AdminDataService {
  list(key) {
    return http.get(this._path(key));
  }
  get(key, id) {
    return http.get(`${this._path(key)}/${id}`);
  }
  create(key, payload) {
    return http.post(this._path(key), payload);
  }
  update(key, id, payload) {
    return http.put(`${this._path(key)}/${id}`, payload);
  }
  listServicesByStructure(structureId) {
    return http.get(`${paths.structures}/${structureId}/services`);
  }
  createServiceForStructure(structureId, payload) {
    return http.post(`${paths.structures}/${structureId}/services`, payload);
  }
  listStrPrtAssByStructure(structureId) {
    return http.get(`${paths.structures}/${structureId}/str-prt-ass`);
  }
  listUserServiceByStructure(structureId) {
    return http.get(`${paths.structures}/${structureId}/user-service`);
  }
  getUserService(id) {
    return http.get(`${paths["user-service"]}/${id}`);
  }
  getUserServiceByEmail(email) {
    return http.get(`${paths["user-service"]}/by-email/${encodeURIComponent(email)}`);
  }

  getHabilAdminRecetteByEmail(email) {
    return http.get(`/admin/users/habil-admin-recette/${encodeURIComponent(email)}`);
  }

  getRecetteAdminCount(email) {
    return http.get(`/admin/users/habil-recette/count/${encodeURIComponent(email)}`);
  }

  getRecetteGlobaleYears() {
    return http.get(`/admin/recette-globale/years`);
  }

  getRecetteGlobale(year) {
    return http.get(`/admin/recette-globale`, { params: { year } });
  }

  createUserService(payload) {
    return http.post(paths["user-service"], payload);
  }
  updateUserService(id, payload) {
    return http.put(`${paths["user-service"]}/${id}`, payload);
  }
  deleteUserService(id) {
    return http.delete(`${paths["user-service"]}/${id}`);
  }
  openIndisMngSec(payload) {
    return http.post(paths["indis-mng-sec"], payload);
  }

  closeIndisMngSec(id, payload) {
    return http.put(`${paths["indis-mng-sec"]}/${id}`, payload);
  }



  getUser(id) {
    return http.get(`${paths.users}/${id}`);
  }
  getUserNameByEmail(email) {
    return http.get(paths["user-by-email"], { params: { email } });
  }
  updateUserNameByEmail(payload) {
    return http.put(paths["user-by-email"], payload);
  }
  enableHabilAdmin(payload) {
    return http.post(`/admin/habil-admin`, payload);
  }
  disableHabilAdmin(id, payload) {
    return http.put(`/admin/habil-admin/${id}/off`, payload);
  }
  enableHabilRecette(payload) {
    return http.post(`/admin/habil-recette`, payload);
  }
  disableHabilRecette(id, payload) {
    return http.put(`/admin/habil-recette/${id}/off`, payload);
  }
  createUser(payload) {
    return http.post(paths.users, payload);
  }
  updateUser(id, payload) {
    return http.put(`${paths.users}/${id}`, payload);
  }
  deleteUser(id) {
    return http.delete(`${paths.users}/${id}`);
  }
  delete(key, id) {
    return http.delete(`${this._path(key)}/${id}`);
  }
  updateStructureLoc(id, payload) {
    return http.put(`${paths.structures}/${id}/loc`, payload);
  }
  habiliterMedecin(payload) {
    return http.post(paths["habiliter-medecin"], payload);
  }

  revokeHabilitation(payload) {
    return http.post(`${paths["habiliter-medecin"]}/revoke`, payload);
  }

  _path(key) {
    const p = paths[key];
    if (!p) throw new Error(`Unknown admin resource key: ${key}`);
    return p;
  }
}

export default new AdminDataService();